import React from 'react';
import { Chats } from '../../../fasades/chats';
import { IChatInfo } from '../../api/llmapi';
import { Conversation } from '../../../fasades/conversation';
import { Util } from '../../../fasades/util';
import { MdDeleteForever } from "react-icons/md";
import { HiOutlineSave } from "react-icons/hi";
import { HiOutlineSaveAs } from "react-icons/hi";
import { TbMessageCirclePlus } from "react-icons/tb";
import { IoClose } from "react-icons/io5";
import { RoundButton } from '../roundbutton';
import './chatlist.css';

interface ChatListProps {
  onExit: () => void;
}


type ChatListState = {
    chats: IChatInfo[];
};

export class ChatList extends React.Component<ChatListProps> {
    state: ChatListState = { chats: [] };

    componentDidMount()
    {
        Chats.getChats().then(data => this.setState({ chats: data }));
    }

    async handleSelect(chat : IChatInfo)
    {
        await Chats.loadChat(chat);
        Chats.getChats().then(data => this.setState({ chats: data }));
        this.props.onExit();
    };

    async onDelete(chat : IChatInfo)
    {
        await Chats.deleteChat(chat);
            if (Conversation.chat !== undefined && Conversation.chat.id === chat.id) {
            Conversation.chat.id = "";
        }

        Chats.refreshChats().then(data => this.setState({ chats: data }));
    }

    async onNewChat()
    {
        await Conversation.newChat();
        Chats.refreshChats().then(data => this.setState({ chats: data }));
        this.props.onExit();
    }

    async onExit()
    {
        this.props.onExit();
    }

    async onSave(saveAsNew : boolean)
    {
        if (Conversation.chat !== undefined) {
            Conversation.chat.id = await Chats.saveChat(saveAsNew);
        }
        Chats.refreshChats().then(data => this.setState({ chats: data }));
    }

    render() {
        const list = this.renderList();
        return (
            <div className="chats">
                <div className="chat-header">
                    <h1 className="chat-title">Chats</h1>
                    <div className="chat-header-actions">
                        <RoundButton
                            description = { false }
                            icon = { TbMessageCirclePlus }
                            name = "New Chat"
                            onClick={ () => this.onNewChat() }/>
                        <RoundButton
                            description = { false }
                            icon = { HiOutlineSaveAs }
                            name ="Save As New Chat" 
                            onClick={ () => this.onSave(true) } />
                        <RoundButton
                            description = { false }
                            icon = {IoClose}
                            name="Back to converstation"
                            onClick={ () => this.onExit() }/>
                    </div>
                </div>
                <ul className="chat-list">{list}</ul>
            </div>
        );
    }

    renderList() : React.JSX.Element[]
    {
        let list = [];
        let i    = 0;

        for (const chat of this.state.chats) {
            const active = chat.id === Conversation.chat?.id;

            list.push(
                <li key={chat.name + i}
                    className={`chat-entry${active ? ' active' : ''}`}
                    onClick={() => this.handleSelect(chat)}>
                    <div >
                        <div className="chatlist-name">{chat.name}</div>
                        <div className="chatlist-time">{Util.formatRelativeTime(new Date(chat.timestamp)) }</div>
                    </div>
                    <div className="chat-actions">
                        { active &&
                        <button title="Save" onClick={(e) => {
                                e.stopPropagation();
                                this.onSave(false) 
                            }}>
                            {React.createElement(HiOutlineSave as React.ComponentType)}
                        </button>}
                        <button title="Delete" onClick={(e) => {
                                e.stopPropagation();
                                this.onDelete(chat)
                            }}>
                            {React.createElement(MdDeleteForever as React.ComponentType)}
                        </button>
                    </div>
                </li>);
            i++;
        }

        return list;
    }
}

